import React, { Component } from "react";

export default class AttestModalForm1 extends Component {
  render() {
    const {
      quickAttest,
      clients,
      accountName,
      reviewConduct,
      handleDataUpdate,
      submitData,
      reviewDate,
      lastDate,
    } = this.props;

    return (
      <div>
        <h5 className="text-start">Client:</h5>
        {quickAttest ? (
          <select
            className="form-select mb-3"
            onChange={(e) => handleDataUpdate("client-name", e.target.value)}
          >
            <option value=""></option>
            {clients
              .filter(
                (c) => c["attestation-status"].toLowerCase() !== "submitted"
              )
              .map((c, i) => (
                <option key={i} value={c["client-name"]}>
                  {c["client-name"]}
                </option>
              ))}
          </select>
        ) : (
          <div className="input-group mb-3">
            <input
              readOnly={true}
              value={accountName}
              className="form-control"
              placeholder="Client Name(s)"
              aria-describedby="basic-addon1"
            />
          </div>
        )}
        <div>
          <h5 className="text-start">Date of Review:</h5>
          <div className="input-group mb-3">
            <input
              style={{
                borderLeft:
                  reviewDate.split("-")[0] === lastDate.split("/")[2]
                    ? "6px solid green"
                    : "6px solid red",
                marginRight: "6px",
              }}
              type="date"
              className="form-control"
              aria-describedby="basic-addon1"
              onChange={(e) => {
                handleDataUpdate("review-date", e.target.value);
              }}
              value={reviewDate}
            />
          </div>
          <h5 className="text-start">Review Conducted:</h5>
          <div className="input-group mb-3">
            <select
              className="form-select"
              style={{
                borderLeft: submitData["review-structure"]
                  ? "6px solid green"
                  : "6px solid red",
              }}
              aria-label="Default select example"
              defaultValue={submitData["review-structure"]}
              onChange={(e) =>
                handleDataUpdate("review-structure", e.target.value)
              }
            >
              <option></option>
              {reviewConduct.map((r, i) => {
                return <option key={i}>{r}</option>;
              })}
            </select>
          </div>
          <h5 className="text-start">
            Has the client’s financial circumstances changed substantially?
          </h5>
          <div
            className="input-group mb-3"
            style={{
              borderLeft:
                submitData["account-substantial-change"] !== ""
                  ? "6px solid green"
                  : "6px solid red",
              marginRight: "6px",
            }}
          >
            <div className="form-check ps-1 ms-4">
              <input
                className="form-check-input"
                type="radio"
                name="flexRadioFinancialSituation"
                id="flexRadioDefault1"
                onChange={() => {
                  handleDataUpdate("account-substantial-change", "Yes");
                }}
                checked={submitData["account-substantial-change"] === "Yes"}
              />
              <label className="form-check-label" htmlFor="flexRadioDefault1">
                Yes
              </label>
            </div>
            <div className="form-check ms-2">
              <input
                className="form-check-input"
                type="radio"
                name="flexRadioFinancialSituation"
                id="flexRadioDefault2"
                onChange={() => {
                  handleDataUpdate("account-substantial-change", "No");
                }}
                checked={submitData["account-substantial-change"] === "No"}
              />
              <label className="form-check-label" htmlFor="flexRadioDefault2">
                No
              </label>
            </div>
          </div>
          <h5 className="text-start">
            Has the client’s needs/objectives/time horizon changed?
          </h5>
          <div
            className="input-group mb-3"
            style={{
              borderLeft:
                submitData["account-r-t-a-changes"] !== ""
                  ? "6px solid green"
                  : "6px solid red",
              marginRight: "6px",
            }}
          >
            <div className="form-check ps-1 ms-4">
              <input
                className="form-check-input"
                type="radio"
                name="flexRadioRTA"
                id="flexRadioDefault1"
                onChange={(e) => {
                  handleDataUpdate("account-r-t-a-changes", "Yes");
                }}
                checked={submitData["account-r-t-a-changes"] === "Yes"}
              />
              <label className="form-check-label" htmlFor="flexRadioDefault1">
                Yes
              </label>
            </div>
            <div className="form-check" style={{ marginLeft: "10px " }}>
              <input
                className="form-check-input"
                type="radio"
                name="flexRadioRTA"
                id="flexRadioDefault2"
                onChange={(e) => {
                  handleDataUpdate("account-r-t-a-changes", "No");
                }}
                checked={submitData["account-r-t-a-changes"] === "No"}
              />
              <label className="form-check-label" htmlFor="flexRadioDefault2">
                No
              </label>
            </div>
          </div>
        </div>
        <h5 className="text-start">
          Does the investment remain in the client’s best interest as an
          advisory client and does the current advisory program continue to meet
          the needs of the client?
        </h5>
        <div
          className="input-group mb-3"
          style={{
            borderLeft:
              submitData["reg-b-i-changes"] !== ""
                ? "6px solid green"
                : "6px solid red",
            marginRight: "6px",
          }}
        >
          <div className="form-check ps-1 ms-4">
            <input
              className="form-check-input"
              type="radio"
              name="RegBI"
              id="flexRadioDefault1"
              onChange={() => {
                handleDataUpdate("reg-b-i-changes", "Yes");
              }}
              checked={submitData["reg-b-i-changes"] === "Yes"}
            />
            <label className="form-check-label" htmlFor="flexRadioDefault1">
              Yes
            </label>
          </div>
          <div className="form-check" style={{ marginLeft: "10px " }}>
            <input
              className="form-check-input"
              type="radio"
              name="RegBI"
              id="flexRadioDefault2"
              onChange={() => {
                handleDataUpdate("reg-b-i-changes", "No");
              }}
              checked={submitData["reg-b-i-changes"] === "No"}
            />
            <label className="form-check-label" htmlFor="flexRadioDefault2">
              No
            </label>
          </div>
        </div>
      </div>
    );
  }
}
